// Inlined line-icon set (dependency-free) — one consistent 24×24 stroke grid,
// currentColor, 1.75 stroke. Replaces the emoji iconography.
import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

function Svg({ children, ...p }: IconProps & { children: React.ReactNode }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...p}
    >
      {children}
    </svg>
  );
}

/* Nav — Bosh sahifa (gauge / control panel) */
export const IconGauge = (p: IconProps) => (
  <Svg {...p}>
    <path d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
    <path d="m14 12 4-3" />
    <path d="M4.5 18a9 9 0 1 1 15 0" />
  </Svg>
);

/* Nav — Ustaxonalar (workshop / wrench) */
export const IconWrench = (p: IconProps) => (
  <Svg {...p}>
    <path d="M14.7 6.3a4 4 0 0 0-5.2 5.2L4 17l3 3 5.5-5.5a4 4 0 0 0 5.2-5.2l-2.6 2.6-2.4-.6-.6-2.4 2.6-2.6Z" />
  </Svg>
);

/* Nav — Aktivatsiya kodlari (key) */
export const IconKey = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="8" cy="8" r="4" />
    <path d="m10.8 10.8 8 8" />
    <path d="m16 15 2 2" />
    <path d="m19 12 2 2" />
  </Svg>
);

/* Nav — Analitika (chart line) */
export const IconChart = (p: IconProps) => (
  <Svg {...p}>
    <path d="M4 4v15a1 1 0 0 0 1 1h15" />
    <path d="m8 15 3-4 3 2 4-6" />
  </Svg>
);

/* Nav — Murojaatlar (message) */
export const IconMessage = (p: IconProps) => (
  <Svg {...p}>
    <path d="M20 15a2 2 0 0 1-2 2H8l-4 3V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2Z" />
  </Svg>
);

/* Nav — So'rovlar (inbox) */
export const IconInbox = (p: IconProps) => (
  <Svg {...p}>
    <path d="M4 13h4l1.5 3h5L16 13h4" />
    <path d="M6.5 5h11l3.5 8v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4Z" />
  </Svg>
);

/* Nav — Haydovchilar (car) */
export const IconCar = (p: IconProps) => (
  <Svg {...p}>
    <path d="M5 11l1.5-4.5A2 2 0 0 1 8.4 5h7.2a2 2 0 0 1 1.9 1.5L19 11" />
    <path d="M3 11h18v5a1 1 0 0 1-1 1h-1a2 2 0 0 1-4 0H9a2 2 0 0 1-4 0H4a1 1 0 0 1-1-1Z" />
    <path d="M7 14h.01M17 14h.01" />
  </Svg>
);

/* UI — phone (call queue) */
export const IconPhone = (p: IconProps) => (
  <Svg {...p}>
    <path d="M15.5 21a12 12 0 0 1-12-12A2.5 2.5 0 0 1 6 6.5h1.7a1 1 0 0 1 1 .8l.6 2.6a1 1 0 0 1-.5 1.1l-1.3.8a10 10 0 0 0 4 4l.8-1.3a1 1 0 0 1 1.1-.5l2.6.6a1 1 0 0 1 .8 1V18A2.5 2.5 0 0 1 15.5 21Z" />
  </Svg>
);

/* Nav — Ilova versiyasi (smartfon). IconPhone bu yerda mos emas — u qo'ng'iroq
   go'shagi, bizga qurilma kerak. */
export const IconSmartphone = (p: IconProps) => (
  <Svg {...p}>
    <rect x="6" y="2.5" width="12" height="19" rx="2.5" />
    <path d="M10.5 18.5h3" />
  </Svg>
);

/* UI — plus */
export const IconPlus = (p: IconProps) => (
  <Svg {...p}>
    <path d="M12 5v14M5 12h14" />
  </Svg>
);

/* UI — arrow-right */
export const IconArrowRight = (p: IconProps) => (
  <Svg {...p}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </Svg>
);

/* UI — logout */
export const IconLogout = (p: IconProps) => (
  <Svg {...p}>
    <path d="M15 5V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1" />
    <path d="M20 12H9m8-3 3 3-3 3" />
  </Svg>
);

/* UI — sun (light) */
export const IconSun = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </Svg>
);

/* UI — moon (dark) */
export const IconMoon = (p: IconProps) => (
  <Svg {...p}>
    <path d="M20 14.5A8 8 0 0 1 9.5 4a7 7 0 1 0 10.5 10.5Z" />
  </Svg>
);

/* UI — download (CSV export) */
export const IconDownload = (p: IconProps) => (
  <Svg {...p}>
    <path d="M12 3v12" />
    <path d="m7 11 5 4 5-4" />
    <path d="M5 21h14" />
  </Svg>
);

/* UI — trend up (growth) */
export const IconTrendUp = (p: IconProps) => (
  <Svg {...p}>
    <path d="M3 17l6-6 4 4 8-8" />
    <path d="M17 7h4v4" />
  </Svg>
);

/* UI — calendar (period) */
export const IconCalendar = (p: IconProps) => (
  <Svg {...p}>
    <rect x="3" y="4.5" width="18" height="16" rx="2" />
    <path d="M3 9h18M8 2.5v4M16 2.5v4" />
  </Svg>
);

/* UI — activity (pulse / active) */
export const IconActivity = (p: IconProps) => (
  <Svg {...p}>
    <path d="M3 12h3l2.5 6L13 5l2.5 7H21" />
  </Svg>
);

/* UI — clock (trial / time) */
export const IconClock = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8" />
    <path d="M12 8v4l2.5 2" />
  </Svg>
);

/* UI — alert (expired / risk) */
export const IconAlert = (p: IconProps) => (
  <Svg {...p}>
    <path d="M12 9v4" />
    <path d="M12 17h.01" />
    <path d="M10.3 4.3 2.8 17a2 2 0 0 0 1.7 3h15a2 2 0 0 0 1.7-3L13.7 4.3a2 2 0 0 0-3.4 0Z" />
  </Svg>
);
